import { memo, useMemo } from "react";
import { UserAlert_Trigger } from "../../../proto/generated/nexus";
import { AlertTriggerInputProps } from "./alertTriggerInput.typings";
import { Box, Chip, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { getSelectedValue } from "../../../util/alerts";

const alertTriggerDisplayNames: Record<UserAlert_Trigger, string> = {
    [UserAlert_Trigger.ONCE]: "Only Once",
    [UserAlert_Trigger.EVERYTIME]: "Every Time",
    [UserAlert_Trigger.ONCE_PER_BAR]: "Once Per Bar",
    [UserAlert_Trigger.ONCE_PER_BAR_CLOSED]: "Once Per Bar Close",
    [UserAlert_Trigger.ONCE_PER_MINUTE]: "Once Per Minute",
    [UserAlert_Trigger.TRIGGER_UNKNOWN]: "",
    [UserAlert_Trigger.UNRECOGNIZED]: ""
}

const alertTriggerHelpTexts: Record<UserAlert_Trigger, string> = {
    [UserAlert_Trigger.ONCE]: "The alert will only trigger once and will not be repeated",
    [UserAlert_Trigger.EVERYTIME]: "The alert will trigger every time the condition is met, but not more than 1 time per minute",
    [UserAlert_Trigger.ONCE_PER_BAR]: "The alert will trigger every time the condition is met, but not more than 1 time per bar",
    [UserAlert_Trigger.ONCE_PER_BAR_CLOSED]: "The alert will trigger every time the condition is met at bar close",
    [UserAlert_Trigger.ONCE_PER_MINUTE]: "The alert will trigger every time the condition is met, but not more than 1 time per minute",
    [UserAlert_Trigger.TRIGGER_UNKNOWN]: "",
    [UserAlert_Trigger.UNRECOGNIZED]: ""
}

const availableTriggers: UserAlert_Trigger[] = [
    UserAlert_Trigger.ONCE,
    UserAlert_Trigger.EVERYTIME,
    UserAlert_Trigger.ONCE_PER_BAR,
    UserAlert_Trigger.ONCE_PER_BAR_CLOSED,
    UserAlert_Trigger.ONCE_PER_MINUTE
]


const AlertTriggerInput: React.FC<AlertTriggerInputProps> = ({trigger, condition, onTriggerChange}) => {

    const {classes} = useStyles()

    const triggerTypes = useMemo(() => {
        const {securityAlertCondition} = condition;
        if (!securityAlertCondition || !securityAlertCondition.lhsExpression) return [];

        const [value] = getSelectedValue(securityAlertCondition.lhsExpression, []);
        if (value === "close") {
            return [UserAlert_Trigger.ONCE, UserAlert_Trigger.EVERYTIME]
        }

        return availableTriggers.filter(v => v !== UserAlert_Trigger.EVERYTIME)
    }, [condition])

    return  (
        <>
            <Box className={classes.container}>
                {triggerTypes.map((t) => <Chip key={t} label={alertTriggerDisplayNames[t]} variant={trigger === t ? 'filled': 'outlined'} onClick={() => onTriggerChange(t)} className={classes.chip} />)}
            </Box>
            <Typography fontSize={'small'} color="textSecondary">{alertTriggerHelpTexts[trigger]}</Typography>
        </>);
}

export default memo(AlertTriggerInput);